import React, { useContext } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { TEXT_ART } from "../../../constants/editor";

let style = Object.assign({}, global);

const TextArtToolbar = () => {
  let { metadata } = useContext(EditorContext);

  // handle click from toolbar
  const handleTextArtIconClick = () => {
    const element = document.getElementById(metadata?.activeWidgetId[0]);

    if (metadata?.activeWidgetType[0] === TEXT_ART && element) {
      const dblClickEvent = new MouseEvent("dblclick", {
        bubbles: true,
        cancelable: true,
        view: window,
      });

      // Dispatch the double-click event
      element.dispatchEvent(dblClickEvent);
    }
  };

  return (
    <li className={cx(style["toolset-group"])}>
      <div className={cx(style["toolset-item"], style["text-art-wrap"])} id="text-art-wrap">
        <span className={cx(style["toolset-action"], style["custom-tooltip"])} onClick={handleTextArtIconClick}>
          <Icon icon="ui-text-art" />
          <div className={cx(style["custom-tooltip-content"], style["top"])}>Text Art</div>
        </span>
      </div>
    </li>
  );
};

export default TextArtToolbar;
